/**
* DevExpress Dashboard (title.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { dashboardTitleSerializationsInfo } from './metadata/_title';
import { SerializableModel } from './serializable-model';
export class DashboardTitle extends SerializableModel {
    constructor(model, serializer, info) {
        super(model || {}, serializer, info);
        this.imageType = ko.observable('none');
        if (this.image64()) {
            this.imageType('embedded');
        }
        else if (this.url()) {
            this.imageType('linked');
        }
        else {
            this.imageType('none');
        }
        this.addDisposable(this.imageType.subscribe(imageType => {
            switch (imageType) {
                case 'embedded':
                    this.url(null);
                    break;
                case 'linked':
                    this.image64(null);
                    break;
                default:
                    this.url(null);
                    this.image64(null);
            }
        }));
    }
    getInfo() {
        return dashboardTitleSerializationsInfo;
    }
}
